module.exports = __webpack_public_path__ + "img/ihar.b__600x600.eaf54da9.jpg";